import { gql } from '@apollo/client';

const LOGIN_MUTATION = gql`
  mutation login($input: LoginInput) {
    loginResult: login(input: $input) {
      result {
        accessToken
        refreshToken
      }
    }
  }
`;

export default LOGIN_MUTATION;
